import { Input } from '@wiggui/ds/Input'

import { composeClasses } from '@wiggot/utils/src/strings'
import { FormInput } from '../hooks'

interface InputCompleteProfileProps {
  input: FormInput
}

export const InputCompleteProfile = ({ input }: InputCompleteProfileProps) => {
  return (
    <Input
      classNameContainer={composeClasses(input?.className, 'w-full')}
      type={input?.type}
      key={input?.name}
      error={input?.isError}
      name={input?.name}
      labelText={input?.label}
      disabled={input?.isDisabled}
      onPhoneCodeChange={(value) => {
        input?.onChangePhoneCode?.(value)
      }}
      value={input?.value ?? undefined}
      onChange={(event) => input?.onChange(event?.target?.value)}
    />
  )
}
